export const properties = {
    oktaRedirectUri: '/osar/msi',
    oktaRedirectUriImplict: '/osar/msi/implicit/callback',
    oktaRedirectUriConfirmation: '/erums/order/confirmation/implicit/callback',
    erumsRedirectCookieName: 'erums-from-uri',
    clientBannerHeader: 'banner',
    headerStoreId: '',
    headerFulfillment: 'instore',
    storeId: '',
    tooltips: {
    },
    bannerConfiguration: {
        tomthumb: {
            banner: 'Tom Thumb',
            logoUrls: {
                color: 'TomThumb_RGB.svg',
                white: 'TomThumb_W.svg'
            }
        },
        albertsons: {
            banner: 'Albertsons',
            logoUrls: {
                color: 'Albertsons_RGB.svg',
                white: 'Albertsons_W.svg'
            }
        },
        vons: {
            banner: 'Vons',
            logoUrls: {
                color: 'Vons_RGB.svg',
                white: 'Vons_W.svg'
            }
        },
        safeway: {
            banner: 'Safeway',
            logoUrls: {
                color: 'Safeway_RGB.svg',
                white: 'Safeway_W.svg'
            }
        },
        randalls: {
            banner: 'Randalls',
            logoUrls: {
                color: 'Randalls_RGB.svg',
                white: 'Randalls_W.svg'
            }
        },
        pavilions: {
            banner: 'Pavilions',
            logoUrls: {
                color: 'Pavilions_RGB.svg',
                white: 'Pavilions_W.svg'
            }
        },
        jewelosco: {
            banner: 'Jewel-Osco',
            logoUrls: {
                color: 'JewelOsco_Vert_Oval_RGB.svg',
                white: 'JewelOsco_Vert_Oval_W.svg'
            }
        },
        carrsqc: {
            banner: 'Carrs',
            logoUrls: {
                color: 'Carrs_RGB.svg',
                white: 'Carrs_W.svg'
            }
        },
        acmemarkets: {
            banner: 'ACME',
            logoUrls: {
                color: 'Acme_RGB.svg',
                white: 'Acme_W.svg'
            }
        },
        shaws: {
            banner: 'Shaws\'s',
            logoUrls: {
                color: 'Shaws_RGB.svg',
                white: 'Shaws_W.svg'
            }
        },
        starmarket: {
            banner: 'Star Market',
            logoUrls: {
                color: 'StarMarket_RGB.svg',
                white: 'StarMarket_W.svg'
            }
        },
        kingsfoodmarkets: {
            banner: 'Kings',
            logoUrls: {
                color: 'Kingsfoodmarkets_RGB.svg',
                white: 'Kingsfoodmarkets_W.svg'
            }
        },
        haggen: {
            banner: 'Haggen',
            logoUrls: {
                color: 'haggen_RGB.svg',
                white: 'haggen_W.svg'
            }
        },
        andronicos: {
            banner: 'Andronico\'s',
            logoUrls: {
                color: 'andronicos_RGB.svg',
                white: 'andronicos_W.svg'
            }
        },
        balduccis: {
            banner: 'Balducci\'s',
            logoUrls: {
                color: 'balduccis_RGB.svg',
                white: 'balduccis_W.svg'
            }
        }
    },
    PromoTypeDescription: {
        BOGO: 'Buy 1 Get 1 Free',
        B2G1: 'Buy Two Get 1 Free'
    },
    timer: {
        lastLoginAllowedTime: 45
    },
    summaryTexts: {
        sumamrySnapText: 'SNAP Eligible Item Total',
        sumamryNonSnapText: 'Non-SNAP Eligible Item Total'
    },
    referralConfig: {
        bannerMapper: {
            safeway: 'SAFEWAY',
            vons: 'VONS',
            randalls: 'RANDALLS',
            tomthumb: 'TOMTHUMB',
            acmemarkets: 'ACMEMARKETS',
            carrsqc: 'CARRSQC',
            jewelosco: 'JEWELOSCO',
            albertsons: 'ALBERTSONS',
            starmarket: 'STARMARKET',
            shaws: 'SHAWS',
            pavilions: 'PAVILIONS',
            kingsfoodmarkets: 'KINGSFOODMARKETS',
            haggen: 'HAGGEN',
            andronicos: 'ANDRONICOS',
            balduccis: 'BALDUCCIS'
        },
        editText: 'Edit',
        headingText: 'Schedule & Save Preferences',
        headingTextManagement: 'Manage Schedule & Save',
        notesHeading: 'Note:',
        fulfillmentMethodHeading: 'Preferred Date/Time Details',
        fulfillmentDetailsHeading: 'Delivery or Pickup',
        paymentHeading: 'Payment Method',
        needHelp: 'Need Help?',
        helpLineNumber: '1-800-555-5555',
        onlineShoppingFAQ: 'About Schedule & Save',
        pickTimeSlot: 'Select a new preferred day and time',
        pickTimeSlotNO: 'Select new date and time window',
        noSlotsInPreferences: 'Add Preferred Day and Time',
        preferredSlotUnavailable: 'Your preferred day and time isn\'t available.',
        pickNewSlotPrompt: 'choose a new date and time window',
        noteText: 'These settings apply to all future Schedule & Save orders.',
        successText: 'You have successfully updated your preferences.',
        errorText: 'Sorry, we\'re having technical difficulties, please check back later.',
        optionsHeadingText: 'Just select the email communication you’d like to receive, and we’ll send news and updates.',
        unSubscribeNote: 'It may take up to 10 business days to be unsubscribed and no longer receive emails. When you unsubscribe, it applies to newsletters, and promotional emails only. You will continue to receive required program confirmation and mandatory notifications.',
        noSubscriptionDefaultHeading: 'Schedule & Save',
        noSubscriptionDefaultBody: 'Make life easier by scheduling your must-have essentials and never run out again.',
        noSubscriptionDefaultText: 'Shop Now',
        updateEmailText: 'Update Email Address',
        emailText: 'Email',
        updateButtonText: 'Update',
        managementAddressHeading: 'Deliver to',
        managementSlotHeading: 'When',
        managementPaymentHeading: 'Pay with',
        FULFILLMENT: 'FULFILLMENT',
        METHOD: 'METHOD',
        DELIVERY: 'DELIVERY',
        PICKUP: 'PICKUP',
        DUG: 'DUG',
        SHOP: 'SHOP',
        AR_FULFILLMENT: 'AR_FULFILLMENT',
        SLOT: 'SLOT',
        preferencesDeliverTo: 'Deliver To:',
        preferencesPickAt: 'Pickup At:',
        managementHeadingSecond: 'Want to learn more about how our Schedule & Save program works?',
        managementHeadingLink: 'About Schedule & Save',
        updatePreferencesLink: 'Preferences',
        driveUp: 'DriveUp',
        fulfillmentDetails: 'Add Delivery address',
        noPickStoreSelected: 'Add Pickup Store Address',
        addLinkText: 'Add',
        backToManagement: 'Back to Manage Schedule & Save',
        fulfillmentTypeOptionText: 'Choose delivery or pickup for your Schedule & Save order.',
        fulfillmentTypeOptionDeliveryText: 'Deliver To',
        fulfillmentTypeOptionPickupText: 'Pick Up',
        inputSearchZipPlaceHolder: 'Enter ZIP Code to get started.',
        storeSearchSize: '10',
        radius: '50',
        expiredPaymentMethod: 'This card is expired',
        expiredManagementPaymentMethod: 'Expired (update payment)',
        selectStoreHeading: 'Select Store',
        addDeliveryAddressHeading: 'Add Delivery Address',
        editDeliveryAddressHeading: 'Edit Delivery Address',
        slotSelectionHeading: 'Fulfillment Details',
        saveButtonLabel: 'Save',
        cancelButtonLabel: 'Cancel',
        addDeliveryAdressNoteText: 'Changing Delivery Address may change availability and pricing of your Auto Replenishment orders.',
        editDeliveryAdressNoteText: 'Changing Delivery Address may change availability and pricing of your Auto Replenishment orders.',
        selectStoreNoteText: 'Changing Store may change availability and pricing of your Auto Replenishment orders.',
        slotDeliveryNoteText: 'Changing fulfillment details may change price and product availability. Slot preference cannot be guarenteed for every Auto Replenish order.',
        slotPickupNoteText: 'Changing fulfillment details may change price and product availability. Slot preference cannot be guarenteed for every Auto Replenish order.',
        nextOrderLabel: 'Next Order',
        noteTextSlotPickerContainer: 'Changing day and time may change price and product availability. Date and time preferences can\'t be guaranteed for every Schedule & Save order.',
        preferredDatendTimeText: 'Preferred Day & Time',
        addressModalNoteText: 'Changing Delivery/Pickup details may change price and product availability.',
        dataUspErrorMessage: 'The address entered cannot be verified with U.S Postal Service records, please try again.',
        cvvTerms1: 'I agree to the ',
        cvvTerms2: 'Schedule & Save terms.',
        cvvTerms3: ' I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for my Schedule & Save orders until I cancel.',
        cvvNoteText: 'Your payment card will be charged on the dates your order is fulfilled.',
        nextOrderDateAndTimeText: 'Next Order Date & Time',
        nextOrderNote: 'Changing date/time may change price and product availability.',
        deliveryDateText: 'Est Delivery Date',
        deliveryDate: 'Mon, 2/15, 9:00 AM - 10:00 AM',
        noAddressSaved: 'Add Delivery/Pickup address',
        noCardSaved: 'Add Credit Card',
        defaultServiceErrorMsg: 'Sorry, we\'re having technical difficulties and working on fixing them, please check back later.',
        noStoreIdPresent: 'Please enter delivery or pickup address to book preferred slots.',
        notARStore: 'Prefered store is not eligible for Schedule & Save Slots selection.',
        noActiveScheduleSave: 'You have no active schedule and save items',
        cvvTermsHeading: 'Schedule & Save Terms',
        cvvTermsHeading2: 'Updates to Schedule & Save Terms & Conditions March 12, 2021',
        unableToChangeText: 'You\'re not able to change your day and time at this time because your next order is being processed.',
        unableToChangeTitle: 'Unable to change day and time preference',
        unableToChangeDeliveryAddress: 'You\'re not able to change your delivery address at this time because your next order is being processed.',
        unableToChangePickupStore: 'You\'re not able to change your pickup store address at this time because your next order is being processed.',
        unableToChangeAddress: 'Unable to change address',
        fulFillmentDaysMessageHeading: 'Next order date/time change is unavailable',
        fulFillmentDaysMessageBody1: 'Date and time changes are currently unavailable because your next order is in process.',
        fulFillmentDaysMessageBody: 'Date and time changes will become available 5 days prior to your order.',
        serviceErrorMessage: 'Apologies, our site is currently experiencing technical difficulties, please try again later.',
        addressErrorMessage: 'Sorry, This address is not available for Schedule & Save orders.'
    },
    sharedAd:{
        subject: 'I saw these deals and thought of you!',
        bodyTxt: 'Thought you might want to save on groceries with these great deals from {banner}!\nTake a look - {link}\n\nEnjoy your day!'
    },
    summaryPageConfig: {
        desktopLogo: '/content/dam/flavoradventure/FA_Lemon.png',
        mobileLogo: '/content/dam/flavoradventure/FA_Lemon.png',
        anonymousHeadline: 'This adventure may have ended but be on the lookout for new chances to win.',
        authenticatedHeadline: 'Thanks for playing! Here’s how you did',
        disablePersonalizedDisplay: false,
        footer: 'We want to hear from you! Tell us about your experience playing Flavor Adventure.',
        surveyLink: 'https://surveymonkey.com',
        xfParentPath: '/content/experience-fragments/xf/games/game-summary-tiles',
        xfParentPathPersonalized: '/content/experience-fragments/xf/games/game-summary-personalized-tiles',
        gameListEmptyMessage: "<p style=&quot;text-align: center;&quot;>We're sorry, but this game is currently not available.</p><p>&nbsp;</p>",
    },
    dataActiveMode: 'normal',
    emptyListMessage: 'emptyListMessage',
    maintenance: 'maintenance',
    dataSingleCard: false,
    dataSweepstakesHeadline: "Congratulations!",
    dataSweepstakesCta: "Got it, don't show again",
    howItWorksNewUser: "Start Playing",
    howItWorksExistingUser: "Got it",
    programMinAge: 0,
    noPrizeMessage: "Nothing here yet",
    playNow: "Play now!",
    availablePrizes: "Available Prizes",
    nothingHereYet : 'Nothing here yet',
    shopToEarn: 'Shop to earn!',
    gameNotAvailable: "The game is not available at this time",
    playProgramName: "Play {programName} for a chance to win the prizes below, and more!",
    sweepstakesEntriesInfo: 'Total sweepstakes entries earned throughout duration of Episodic Game Play. Sweepstake entries entered in the weekly drawing for the week the entry was earned.',
    disclaimerText: 'It may take up to 48 hours to process new activity.',
    PlayEarn: 'Play & Earn',
    PlayEarnSub: 'Supercharge your savings as offerings go live.',
    gamesHeading: 'Games',
    gamesSub: 'Discover fun ways to earn prizes and discounts.',
    BonusPath: 'Bonus Path',
    BonusPathSub: 'Complete offers to unlock bonus savings.',
    noGamesBonus: 'No Games or Bonus Path at this time. Check back later.',
    continueExploring: 'Continue exploring more ways to '

};
